



// import React, {
//   createContext,
//   useContext,
//   useEffect,
//   useRef,
//   useState,
// } from "react";

// import {
//   getTranslationStatus,
// } from "../api/serverApi";

// import { useMsal } from "@azure/msal-react";
// import { getValidAccessToken } from "../services/garphService";
// import * as microsoftTeams from "@microsoft/teams-js";

// const BackgroundAIJobContext = createContext(null);

// export const BackgroundAIJobProvider = ({
//   children,
// }) => {
//   const { instance, accounts } = useMsal();

//   // =========================================================
//   // TRANSLATION JOBS
//   // =========================================================

//   const [
//     translationJobs,
//     setTranslationJobs,
//   ] = useState({});

//   // =========================================================
//   // GLOBAL NOTIFICATIONS
//   // =========================================================

//   const [
//     notifications,
//     setNotifications,
//   ] = useState([]);

//   // =========================================================
//   // POLLING REFERENCES
//   // =========================================================

//   const pollingRefs = useRef({});

//   // =========================================================
//   // TEAMS CHECK
//   // =========================================================

//   const isInTeams = () => {
//     try {
//       return window.parent !== window.self;
//     } catch {
//       return false;
//     }
//   };

//   // =========================================================
//   // GET ACCESS TOKEN
//   // =========================================================

//   const getToken = async () => {
//     if (isInTeams()) {
//       return await new Promise(
//         (resolve, reject) => {
//           microsoftTeams.authentication.getAuthToken(
//             {
//               successCallback: resolve,
//               failureCallback: reject,
//               resources: [
//                 "https://graph.microsoft.com",
//               ],
//             }
//           );
//         }
//       );
//     }

//     return await getValidAccessToken(
//       instance,
//       accounts
//     );
//   };

//   // =========================================================
//   // ADD GLOBAL NOTIFICATION
//   // =========================================================

//   const addNotification = ({
//     type = "info",
//     title,
//     message,
//     documentId = null,
//   }) => {
//     const notification = {
//       id: `${Date.now()}-${Math.random()}`,
//       type,
//       title,
//       message,
//       documentId,
//       read: false,
//       createdAt:
//         new Date().toISOString(),
//     };

//     setNotifications((prev) => [
//       notification,
//       ...prev,
//     ]);

//     console.log(
//       "Global notification added:",
//       notification
//     );
//   };

//   // =========================================================
//   // MARK NOTIFICATION AS READ
//   // =========================================================

//   const markNotificationAsRead = (
//     notificationId
//   ) => {
//     setNotifications((prev) =>
//       prev.map((notification) =>
//         notification.id ===
//         notificationId
//           ? {
//               ...notification,
//               read: true,
//             }
//           : notification
//       )
//     );
//   };

//   // =========================================================
//   // CLEAR ALL NOTIFICATIONS
//   // =========================================================

//   const clearNotifications = () => {
//     setNotifications([]);
//   };

//   // =========================================================
//   // START TRANSLATION
//   // =========================================================

//   const startTranslation = async (
//     documentId
//   ) => {
//     const {
//       generateTranslation,
//     } = await import(
//       "../api/serverApi"
//     );

//     const token = await getToken();

//     console.log(
//       "Starting background translation:",
//       documentId
//     );

//     const response =
//       await generateTranslation(
//         documentId,
//         token
//       );

//     console.log(
//       "Translation Generate Response:",
//       response.data
//     );

//     const jobId =
//       response.data?.job_id;

//     if (!jobId) {
//       throw new Error(
//         "Translation job ID was not returned by the server."
//       );
//     }

//     // Store processing job globally
//     setTranslationJobs((prev) => ({
//       ...prev,

//       [documentId]: {
//         documentId,
//         jobId,
//         status: "processing",
//         download_url: "",
//       },
//     }));

//     console.log(
//       "Background translation started:",
//       {
//         documentId,
//         jobId,
//       }
//     );

//     return {
//       documentId,
//       jobId,
//     };
//   };

//   // =========================================================
//   // POLL TRANSLATION
//   // =========================================================

//   const pollTranslation = async (
//     documentId,
//     jobId
//   ) => {
//     // Prevent duplicate polling
//     if (
//       pollingRefs.current[documentId]
//     ) {
//       console.log(
//         "Translation polling already running:",
//         documentId
//       );

//       return;
//     }

//     pollingRefs.current[documentId] =
//       true;

//     try {
//       const maxAttempts = 225;

//       // 225 × 4 seconds = 15 minutes
//       for (
//         let attempt = 0;
//         attempt < maxAttempts;
//         attempt++
//       ) {
//         // Wait 4 seconds
//         await new Promise(
//           (resolve) =>
//             setTimeout(resolve, 4000)
//         );

//         // Check if polling was stopped
//         if (
//           !pollingRefs.current[
//             documentId
//           ]
//         ) {
//           console.log(
//             "Translation polling stopped:",
//             documentId
//           );

//           return;
//         }

//         // IMPORTANT:
//         // Get fresh token on every API request
//         const token = await getToken();

//         const statusResponse =
//           await getTranslationStatus(
//             documentId,
//             jobId,
//             token
//           );

//         const result =
//           statusResponse.data;

//         console.log(
//           `Translation Status - ${documentId} - Attempt ${
//             attempt + 1
//           }:`,
//           result
//         );

//         // =====================================================
//         // PROCESSING
//         // =====================================================

//         if (
//           result.status ===
//           "processing"
//         ) {
//           continue;
//         }

//         // =====================================================
//         // FAILED
//         // =====================================================

//         if (
//           result.status === "failed"
//         ) {
//           console.error(
//             "Translation failed:",
//             result
//           );

//           setTranslationJobs(
//             (prev) => ({
//               ...prev,

//               [documentId]: {
//                 ...prev[documentId],

//                 status: "failed",

//                 error:
//                   result.error ||
//                   result.message ||
//                   "Translation failed.",
//               },
//             })
//           );

//           delete pollingRefs.current[
//             documentId
//           ];

//           // Optional failure notification
//           addNotification({
//             type: "error",
//             title: "Translation Failed",
//             message:
//               result.error ||
//               "Translation failed. Please try again.",
//             documentId,
//           });

//           return;
//         }

//         // =====================================================
//         // DONE
//         // =====================================================

//         if (
//           result.status === "done"
//         ) {
//           console.log(
//             "Translation completed:",
//             result
//           );

//           // Save completed job
//           setTranslationJobs(
//             (prev) => ({
//               ...prev,

//               [documentId]: {
//                 ...prev[documentId],

//                 documentId,

//                 jobId,

//                 status: "done",

//                 download_url:
//                   result?.download_url ||
//                   "",

//                 result,
//               },
//             })
//           );

//           // Stop polling
//           delete pollingRefs.current[
//             documentId
//           ];

//           // ===================================================
//           // GLOBAL IN-APP NOTIFICATION
//           // ===================================================

//           addNotification({
//             type: "translation",
//             title: "Translation Ready",
//             message:
//               "The translated document is ready to preview.",
//             documentId,
//           });

//           return;
//         }

//         // =====================================================
//         // UNKNOWN STATUS
//         // =====================================================

//         throw new Error(
//           `Unknown translation status: ${result.status}`
//         );
//       }

//       // =======================================================
//       // TIMEOUT
//       // =======================================================

//       setTranslationJobs(
//         (prev) => ({
//           ...prev,

//           [documentId]: {
//             ...prev[documentId],

//             status: "failed",

//             error:
//               "This is taking longer than expected. Please try again.",
//           },
//         })
//       );

//       delete pollingRefs.current[
//         documentId
//       ];

//       addNotification({
//         type: "error",
//         title: "Translation Timeout",
//         message:
//           "Translation is taking longer than expected. Please try again.",
//         documentId,
//       });
//     } catch (error) {
//       console.error(
//         "Background translation polling failed:",
//         error
//       );

//       setTranslationJobs(
//         (prev) => ({
//           ...prev,

//           [documentId]: {
//             ...prev[documentId],

//             status: "failed",

//             error:
//               error?.response?.data
//                 ?.detail ||
//               error?.response?.data
//                 ?.error ||
//               error?.message ||
//               "Translation failed.",
//           },
//         })
//       );

//       delete pollingRefs.current[
//         documentId
//       ];

//       addNotification({
//         type: "error",
//         title: "Translation Failed",
//         message:
//           error?.response?.data
//             ?.detail ||
//           error?.response?.data
//             ?.error ||
//           error?.message ||
//           "Translation failed.",
//         documentId,
//       });
//     }
//   };

//   // =========================================================
//   // START TRANSLATION + BACKGROUND POLLING
//   // =========================================================

//   const startTranslationJob = async (
//     documentId
//   ) => {
//     const job =
//       await startTranslation(
//         documentId
//       );

//     // Start polling without awaiting it
//     pollTranslation(
//       job.documentId,
//       job.jobId
//     );

//     return job;
//   };

//   // =========================================================
//   // CLEAR TRANSLATION JOB
//   // =========================================================

//   const clearTranslationJob = (
//     documentId
//   ) => {
//     // Stop polling
//     delete pollingRefs.current[
//       documentId
//     ];

//     // Remove translation job
//     setTranslationJobs((prev) => {
//       const updated = {
//         ...prev,
//       };

//       delete updated[documentId];

//       return updated;
//     });

//     console.log(
//       "Translation job cleared:",
//       documentId
//     );
//   };

//   // =========================================================
//   // CLEANUP
//   // =========================================================

//   useEffect(() => {
//     return () => {
//       Object.keys(
//         pollingRefs.current
//       ).forEach((documentId) => {
//         delete pollingRefs.current[
//           documentId
//         ];
//       });
//     };
//   }, []);

//   // =========================================================
//   // PROVIDER
//   // =========================================================

//   return (
//     <BackgroundAIJobContext.Provider
//       value={{
//         // Translation
//         translationJobs,
//         startTranslationJob,
//         clearTranslationJob,

//         // Notifications
//         notifications,
//         addNotification,
//         markNotificationAsRead,
//         clearNotifications,
//       }}
//     >
//       {children}
//     </BackgroundAIJobContext.Provider>
//   );
// };

// // ===========================================================
// // HOOK
// // ===========================================================

// export const useBackgroundAIJobs = () => {
//   const context = useContext(
//     BackgroundAIJobContext
//   );

//   if (!context) {
//     throw new Error(
//       "useBackgroundAIJobs must be used inside BackgroundAIJobProvider"
//     );
//   }

//   return context;
// };

// export default BackgroundAIJobContext;





import React, {
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";

import {
  getTranslationStatus,
  getSummaryStatus,
} from "../api/serverApi";

import { useMsal } from "@azure/msal-react";
import { getValidAccessToken } from "../services/garphService";
import * as microsoftTeams from "@microsoft/teams-js";

const BackgroundAIJobContext = createContext(null);

// =========================================================
// POLLING CONFIG
// =========================================================

const POLL_INTERVAL_MS = 10000;         // 10 seconds
const MAX_ATTEMPTS = 180;               // 180 × 10s = 30 minutes
const TRANSIENT_HTTP_STATUSES = [502, 503, 504];

// Decide whether an error is "retryable" (transient) or fatal.
const isTransientError = (error) => {
  // Axios response errors
  const status = error?.response?.status;
  if (status && TRANSIENT_HTTP_STATUSES.includes(status)) {
    return true;
  }

  // No HTTP response (network failure, CORS, DNS, timeout)
  if (!error?.response) {
    const code = error?.code || "";
    const msg = (error?.message || "").toLowerCase();

    if (
      code === "ECONNABORTED" ||
      code === "ECONNRESET" ||
      code === "ETIMEDOUT" ||
      code === "ERR_NETWORK" ||
      msg.includes("network error") ||
      msg.includes("timeout")
    ) {
      return true;
    }
  }

  return false;
};

export const BackgroundAIJobProvider = ({ children }) => {
  const { instance, accounts } = useMsal();

  // =========================================================
  // TRANSLATION JOBS
  // =========================================================

  const [translationJobs, setTranslationJobs] = useState({});

  // =========================================================
  // SUMMARY JOBS
  // =========================================================

  const [summaryJobs, setSummaryJobs] = useState({});

  // =========================================================
  // GLOBAL NOTIFICATIONS
  // =========================================================

  const [notifications, setNotifications] = useState([]);

  // =========================================================
  // POLLING REFERENCES
  // =========================================================

  const pollingRefs = useRef({});

  // =========================================================
  // TEAMS CHECK
  // =========================================================

  const isInTeams = () => {
    try {
      return window.parent !== window.self;
    } catch {
      return false;
    }
  };

  // =========================================================
  // GET ACCESS TOKEN
  // =========================================================

  const getToken = async () => {
    if (isInTeams()) {
      return await new Promise((resolve, reject) => {
        microsoftTeams.authentication.getAuthToken({
          successCallback: resolve,
          failureCallback: reject,
          resources: ["https://graph.microsoft.com"],
        });
      });
    }

    return await getValidAccessToken(instance, accounts);
  };

  // =========================================================
  // ADD GLOBAL NOTIFICATION
  // =========================================================

  const addNotification = ({
    type = "info",
    title,
    message,
    documentId = null,
  }) => {
    const notification = {
      id: `${Date.now()}-${Math.random()}`,
      type,
      title,
      message,
      documentId,
      read: false,
      createdAt: new Date().toISOString(),
    };

    setNotifications((prev) => [notification, ...prev]);

    console.log("Global notification added:", notification);
  };

  // =========================================================
  // MARK NOTIFICATION AS READ
  // =========================================================

  const markNotificationAsRead = (notificationId) => {
    setNotifications((prev) =>
      prev.map((notification) =>
        notification.id === notificationId
          ? { ...notification, read: true }
          : notification
      )
    );
  };

  // =========================================================
  // CLEAR ALL NOTIFICATIONS
  // =========================================================

  const clearNotifications = () => {
    setNotifications([]);
  };

  // =========================================================
  // =========================================================
  // TRANSLATION
  // =========================================================
  // =========================================================

  const startTranslation = async (documentId) => {
    const { generateTranslation } = await import("../api/serverApi");

    const token = await getToken();

    console.log("Starting background translation:", documentId);

    const response = await generateTranslation(documentId, token);

    console.log("Translation Generate Response:", response.data);

    const jobId = response.data?.job_id;

    if (!jobId) {
      throw new Error(
        "Translation job ID was not returned by the server."
      );
    }

    setTranslationJobs((prev) => ({
      ...prev,
      [documentId]: {
        documentId,
        jobId,
        status: "processing",
        download_url: "",
      },
    }));

    console.log("Background translation started:", { documentId, jobId });

    return { documentId, jobId };
  };

  // =========================================================
  // POLL TRANSLATION
  // =========================================================

  const pollTranslation = async (documentId, jobId) => {
    const pollingKey = `translation_${documentId}`;

    if (pollingRefs.current[pollingKey]) {
      console.log("Translation polling already running:", documentId);
      return;
    }

    pollingRefs.current[pollingKey] = true;

    try {
      for (let attempt = 0; attempt < MAX_ATTEMPTS; attempt++) {
        // Wait before polling
        await new Promise((resolve) =>
          setTimeout(resolve, POLL_INTERVAL_MS)
        );

        // Stopped externally?
        if (!pollingRefs.current[pollingKey]) {
          console.log("Translation polling stopped:", documentId);
          return;
        }

        // -----------------------------------------------------
        // Fetch status in its own try/catch so transient
        // errors don't kill the whole polling loop.
        // -----------------------------------------------------
        let result;

        try {
          const token = await getToken();

          const statusResponse = await getTranslationStatus(
            documentId,
            jobId,
            token
          );

          result = statusResponse.data;
        } catch (statusError) {
          if (isTransientError(statusError)) {
            const httpStatus =
              statusError?.response?.status ?? "network";

            console.warn(
              `Translation status transient error (${httpStatus}) - ` +
                `${documentId} - Attempt ${attempt + 1}. ` +
                `Continuing to poll...`
            );

            continue;
          }

          // Non-transient (401/403/404/etc.) — fail now
          throw statusError;
        }

        console.log(
          `Translation Status - ${documentId} - Attempt ${
            attempt + 1
          }:`,
          result
        );

        // =====================================================
        // PROCESSING
        // =====================================================

        if (result.status === "processing") {
          continue;
        }

        // =====================================================
        // FAILED (backend explicitly said so)
        // =====================================================

        if (result.status === "failed") {
          console.error("Translation failed:", result);

          setTranslationJobs((prev) => ({
            ...prev,
            [documentId]: {
              ...prev[documentId],
              status: "failed",
              error:
                result.error ||
                result.message ||
                "Translation failed.",
            },
          }));

          delete pollingRefs.current[pollingKey];

          addNotification({
            type: "error",
            title: "Translation Failed",
            message:
              result.error ||
              result.message ||
              "Translation failed. Please try again.",
            documentId,
          });

          return;
        }

        // =====================================================
        // DONE
        // =====================================================

        if (result.status === "done") {
          console.log("Translation completed:", result);

          setTranslationJobs((prev) => ({
            ...prev,
            [documentId]: {
              ...prev[documentId],
              documentId,
              jobId,
              status: "done",
              download_url: result?.download_url || "",
              result,
            },
          }));

          delete pollingRefs.current[pollingKey];

          addNotification({
            type: "translation",
            title: "Translation Ready",
            message:
              "The translated document is ready to preview.",
            documentId,
          });

          return;
        }

        // =====================================================
        // UNKNOWN STATUS
        // =====================================================

        throw new Error(
          `Unknown translation status: ${result.status}`
        );
      }

      // =======================================================
      // TIMEOUT (30 minutes reached)
      // =======================================================

      setTranslationJobs((prev) => ({
        ...prev,
        [documentId]: {
          ...prev[documentId],
          status: "failed",
          error:
            "This is taking longer than expected. Please try again.",
        },
      }));

      delete pollingRefs.current[pollingKey];

      addNotification({
        type: "error",
        title: "Translation Timeout",
        message:
          "Translation is taking longer than expected. Please try again.",
        documentId,
      });
    } catch (error) {
      console.error(
        "Background translation polling failed:",
        error
      );

      setTranslationJobs((prev) => ({
        ...prev,
        [documentId]: {
          ...prev[documentId],
          status: "failed",
          error:
            error?.response?.data?.detail ||
            error?.response?.data?.error ||
            error?.message ||
            "Translation failed.",
        },
      }));

      delete pollingRefs.current[pollingKey];

      addNotification({
        type: "error",
        title: "Translation Failed",
        message:
          error?.response?.data?.detail ||
          error?.response?.data?.error ||
          error?.message ||
          "Translation failed.",
        documentId,
      });
    }
  };

  // =========================================================
  // START TRANSLATION + BACKGROUND POLLING
  // =========================================================

  const startTranslationJob = async (documentId) => {
    const job = await startTranslation(documentId);

    // Fire and forget
    pollTranslation(job.documentId, job.jobId);

    return job;
  };

  // =========================================================
  // CLEAR TRANSLATION JOB
  // =========================================================

  const clearTranslationJob = (documentId) => {
    const pollingKey = `translation_${documentId}`;

    delete pollingRefs.current[pollingKey];

    setTranslationJobs((prev) => {
      const updated = { ...prev };
      delete updated[documentId];
      return updated;
    });

    console.log("Translation job cleared:", documentId);
  };

  // =========================================================
  // =========================================================
  // SUMMARY
  // =========================================================
  // =========================================================

  const startSummary = async (documentId) => {
    const { generateSummary } = await import("../api/serverApi");

    const token = await getToken();

    console.log("Starting background summary:", documentId);

    const response = await generateSummary(documentId, token);

    console.log("Summary Generate Response:", response.data);

    const jobId = response.data?.job_id;

    if (!jobId) {
      throw new Error(
        "Summary job ID was not returned by the server."
      );
    }

    setSummaryJobs((prev) => ({
      ...prev,
      [documentId]: {
        documentId,
        jobId,
        status: "processing",
        result: null,
      },
    }));

    console.log("Background summary started:", { documentId, jobId });

    return { documentId, jobId };
  };

  // =========================================================
  // POLL SUMMARY
  // =========================================================

  const pollSummary = async (documentId, jobId) => {
    const pollingKey = `summary_${documentId}`;

    if (pollingRefs.current[pollingKey]) {
      console.log("Summary polling already running:", documentId);
      return;
    }

    pollingRefs.current[pollingKey] = true;

    try {
      for (let attempt = 0; attempt < MAX_ATTEMPTS; attempt++) {
        await new Promise((resolve) =>
          setTimeout(resolve, POLL_INTERVAL_MS)
        );

        if (!pollingRefs.current[pollingKey]) {
          console.log("Summary polling stopped:", documentId);
          return;
        }

        // -----------------------------------------------------
        // Fetch status in its own try/catch so transient
        // errors don't kill the whole polling loop.
        // -----------------------------------------------------
        let result;

        try {
          const token = await getToken();

          const statusResponse = await getSummaryStatus(
            documentId,
            jobId,
            token
          );

          result = statusResponse.data;
        } catch (statusError) {
          if (isTransientError(statusError)) {
            const httpStatus =
              statusError?.response?.status ?? "network";

            console.warn(
              `Summary status transient error (${httpStatus}) - ` +
                `${documentId} - Attempt ${attempt + 1}. ` +
                `Continuing to poll...`
            );

            continue;
          }

          throw statusError;
        }

        console.log(
          `Summary Status - ${documentId} - Attempt ${
            attempt + 1
          }:`,
          result
        );

        // =====================================================
        // PROCESSING
        // =====================================================

        if (result.status === "processing") {
          continue;
        }

        // =====================================================
        // FAILED (backend explicitly said so)
        // =====================================================

        if (result.status === "failed") {
          console.error("Summary failed:", result);

          setSummaryJobs((prev) => ({
            ...prev,
            [documentId]: {
              ...prev[documentId],
              status: "failed",
              error:
                result.error ||
                result.message ||
                "Summary generation failed.",
            },
          }));

          delete pollingRefs.current[pollingKey];

          addNotification({
            type: "error",
            title: "Summary Failed",
            message:
              result.error ||
              result.message ||
              "Summary generation failed. Please try again.",
            documentId,
          });

          return;
        }

        // =====================================================
        // DONE
        // =====================================================

        if (result.status === "done") {
          console.log("Summary completed:", result);

          setSummaryJobs((prev) => ({
            ...prev,
            [documentId]: {
              ...prev[documentId],
              documentId,
              jobId,
              status: "done",
              result,
            },
          }));

          delete pollingRefs.current[pollingKey];

          addNotification({
            type: "summary",
            title: "Summary Ready",
            message:
              "The document summary is ready to preview.",
            documentId,
          });

          return;
        }

        // =====================================================
        // UNKNOWN STATUS
        // =====================================================

        throw new Error(
          `Unknown summary status: ${result.status}`
        );
      }

      // =======================================================
      // TIMEOUT (30 minutes reached)
      // =======================================================

      setSummaryJobs((prev) => ({
        ...prev,
        [documentId]: {
          ...prev[documentId],
          status: "failed",
          error:
            "This is taking longer than expected. Please try again.",
        },
      }));

      delete pollingRefs.current[pollingKey];

      addNotification({
        type: "error",
        title: "Summary Timeout",
        message:
          "Summary generation is taking longer than expected. Please try again.",
        documentId,
      });
    } catch (error) {
      console.error(
        "Background summary polling failed:",
        error
      );

      setSummaryJobs((prev) => ({
        ...prev,
        [documentId]: {
          ...prev[documentId],
          status: "failed",
          error:
            error?.response?.data?.detail ||
            error?.response?.data?.error ||
            error?.message ||
            "Summary generation failed.",
        },
      }));

      delete pollingRefs.current[pollingKey];

      addNotification({
        type: "error",
        title: "Summary Failed",
        message:
          error?.response?.data?.detail ||
          error?.response?.data?.error ||
          error?.message ||
          "Summary generation failed.",
        documentId,
      });
    }
  };

  // =========================================================
  // START SUMMARY + BACKGROUND POLLING
  // =========================================================

  const startSummaryJob = async (documentId) => {
    const job = await startSummary(documentId);

    // Fire and forget
    pollSummary(job.documentId, job.jobId);

    return job;
  };

  // =========================================================
  // CLEAR SUMMARY JOB
  // =========================================================

  const clearSummaryJob = (documentId) => {
    const pollingKey = `summary_${documentId}`;

    delete pollingRefs.current[pollingKey];

    setSummaryJobs((prev) => {
      const updated = { ...prev };
      delete updated[documentId];
      return updated;
    });

    console.log("Summary job cleared:", documentId);
  };

  // =========================================================
  // CLEANUP
  // =========================================================

  useEffect(() => {
    return () => {
      Object.keys(pollingRefs.current).forEach((key) => {
        delete pollingRefs.current[key];
      });
    };
  }, []);

  // =========================================================
  // PROVIDER
  // =========================================================

  return (
    <BackgroundAIJobContext.Provider
      value={{
        // TRANSLATION
        translationJobs,
        startTranslationJob,
        clearTranslationJob,

        // SUMMARY
        summaryJobs,
        startSummaryJob,
        clearSummaryJob,

        // NOTIFICATIONS
        notifications,
        addNotification,
        markNotificationAsRead,
        clearNotifications,
      }}
    >
      {children}
    </BackgroundAIJobContext.Provider>
  );
};

// ===========================================================
// HOOK
// ===========================================================

export const useBackgroundAIJobs = () => {
  const context = useContext(BackgroundAIJobContext);

  if (!context) {
    throw new Error(
      "useBackgroundAIJobs must be used inside BackgroundAIJobProvider"
    );
  }

  return context;
};

export default BackgroundAIJobContext;